import styled from 'styled-components';

export const ContentWrapperStyled = styled.div`
  position: relative;
  border-radius: 10px;
`;
